<template>
    <RoundedContainer>
        <h5 class="title is-5 m-2 p-2">Please select a destination and whether to publish</h5>
        
        <DropDown 
            class="m-1 p-1"
            :items="dropDownItems"
            :starterText="dropdownText"
            @selected="onSelected"
            :switchToSelected="true"
            :disabled="false"
            :useTextInput="false"
        />

        <div class="has-text-centered m-2 p-1">
            <label class="checkbox">
                <input
                    type="checkbox"
                    id="publishCheckbox"
                    :disabled="disablePublish"
                >
                Publish
            </label>
        </div>
    </RoundedContainer>

        <div class="has-text-centered">
            <button 
                @click="checkIfPublished(); submitFields();"
                class="button is-primary mt-3 p-5 slightly-rounded"
                :disabled="disableSubmitButton">
                <span>Submit</span>
            </button>
        </div>

</template>

<script>
import DropDown from "@/widgets/DropDown.vue"
import RoundedContainer from '@/widgets/RoundedContainer.vue'
export default {
    emits: ['saveFields'],
    data() {
        return {
            showDropdown: false,
            dropDownItems: ['S3', 'Locally'],
            dropdownText: 'Select Destination',
            isActive: '',
            fields: {
                destination: '',
                published: false
            },
            disableSubmitButton: true
        };
    },
    methods: {
        onSelected(destination){
            this.fields.destination = destination
            this.disableSubmitButton = false
        },
        checkIfPublished() {
            if (document.getElementById('publishCheckbox').checked) {
                this.fields.published = true;
            }
            else {
                this.fields.published = false;
            }
        },
        submitFields() {
            this.$emit('saveFields', { 'saveFields': this.fields });
        }
    },
    computed: {
        disablePublish() {
            if (this.fields.destination === 'Locally') {
                return true;
            }
            else {
                return false;
            }
        }
    },
    watch: {
        'fields.destination'() {
            if (this.fields.destination === 'Locally') {
                document.getElementById('publishCheckbox').checked = false;
                this.fields.published = false;
            }
        }
    },
    components: { DropDown, RoundedContainer }
}

</script>